import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../../ui/gzCheckbox';
import { GzDropdownWebComponent } from '../../../../../ui/gzDropdown';

export class IntegrityMonitorCustomRuleActionItemView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;

    $checkboxFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
    $dropdownFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $dropdownContainer: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),

      $checkboxFormField: this.shadow.querySelector('#checkbox-form-field'),
      $dropdownFormField: this.shadow.querySelector('#dropdown-form-field'),
      $dropdownContainer: this.shadow.querySelector('#dropdown-container'),
    };
  }

  buildSuccessView(data: any) {}

  buildErrorView(error: any) {}
}
